/**
 * Busquedas que no encontraron nada (ADM-07).
 *
 * Es la lista de lo que la gente vino a comprar y el catalogo no supo
 * responder: o falta el producto, o esta con otro nombre. Cada fila lleva un
 * enlace para repetir la busqueda en la tienda y ver con los propios ojos que
 * pasa.
 *
 * De la busqueda por foto solo llega el hecho de que ocurrio: la imagen que
 * sube el comprador no se guarda nunca.
 */
import { Link, useSearchParams } from 'react-router-dom';

import { BarraAdmin } from '../../componentes/administracion/BarraAdmin';
import { Tabla } from '../../componentes/administracion/Tabla';
import { AvisoError, Cargando } from '../../componentes/comunes/EstadoPeticion';
import { Paginador } from '../../componentes/catalogo/Paginador';
import { usePeticion } from '../../hooks/use-peticion';
import { Seo } from '../../seo/Seo';
import { obtenerBusquedasSinResultado } from '../../servicios/administracion.servicio';
import { fechaHora, numero } from '../../utilidades/formato';
import { rutas } from '../../utilidades/rutas';

export function Busquedas() {
  const [parametros] = useSearchParams();
  const pagina = Number(parametros.get('pagina') ?? '1');

  const { estado, datos, error } = usePeticion(
    (senal) => obtenerBusquedasSinResultado({ pagina, senal }),
    [pagina],
  );

  return (
    <>
      <Seo
        titulo="Búsquedas sin resultado"
        descripcion="Lo que buscan tus clientes y el catálogo no responde."
        ruta={rutas.administracion.busquedas()}
        sinIndexar
      />

      <BarraAdmin
        titulo="Búsquedas sin resultado"
        bajada="Lo que buscan tus clientes y el catálogo no responde"
      />

      <div className="admin-cuerpo">
        {estado === 'cargando' ? <Cargando que="las búsquedas" /> : null}
        {estado === 'error' ? <AvisoError error={error} /> : null}

        {datos !== null ? (
          <>
            <Tabla
              titulo="Términos buscados sin resultado"
              encabezados={
                <>
                  <th scope="col" className="col-principal">
                    Término buscado
                  </th>
                  <th scope="col" className="der">
                    Veces
                  </th>
                  <th scope="col">Última vez</th>
                  <th scope="col">
                    <span className="solo-lectores">Acciones</span>
                  </th>
                </>
              }
            >
              {datos.items.map((busqueda) => (
                <tr key={busqueda.termino}>
                  <th scope="row" className="partible">
                    {busqueda.termino}
                  </th>
                  <td className="der num">{numero(busqueda.veces)}</td>
                  <td>
                    <time dateTime={busqueda.ultimaVez}>{fechaHora(busqueda.ultimaVez)}</time>
                  </td>
                  <td className="der">
                    <Link className="btn btn-xs btn-suave" to={rutas.busqueda(busqueda.termino)}>
                      Probar en la tienda
                    </Link>
                  </td>
                </tr>
              ))}
            </Tabla>

            <Paginador
              pagina={datos.pagina}
              total={datos.total}
              porPagina={datos.porPagina}
              ruta={rutas.administracion.busquedas()}
            />
          </>
        ) : null}
      </div>
    </>
  );
}
